import { UrlDescriptor } from '@shared/abstract/url-descriptor.interface';


export class TakeDescriptor implements UrlDescriptor {
  constructor(private value: number) {}

  serialize = () => `${this.value}`;
}
